import { mount } from 'svelte'
import { Conversation } from '../components'

export function processTableData(data) {
  const tableData = data.map((row, i) => {
    row.id = i
    row.OverallScore = Number(row.OverallScore).toFixed(1)
    return row
  })

  return tableData
}

export async function makeConversation(){
  const convoConfigEle = document.getElementById('conversation')
  
  if (convoConfigEle) {
    const convoSetObj = {
      leftId: convoConfigEle.dataset.leftid,
      rightId: convoConfigEle.dataset.rightid
    }

    mount(Conversation, {
      target: convoConfigEle,
      props: convoSetObj
    })
  }
}